module.exports = __webpack_public_path__ + "static/media/HCMM805.9ca1a5d3.jpg";